import React from 'react';
import styled, { DefaultTheme } from 'styled-components';

import ClockSVG from './clock.svg';

type TaskElementProps = {
  theme: DefaultTheme;
  programId: number;
};

interface InfoCardProps {
  label: string;
  text: string;
  programId?: number;
  type?: 'text' | 'time' | 'program';
}

const CardContainer = styled.div`
  vertical-align: top;
  display: inline-block;
  margin-right: 10px;
`;

const InnerContainer = styled.div(({ theme }) => {
  const { color } = theme.new;
  return `
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: ${color.neutral[3]};
    border: 1px solid ${color.neutral[4]};
    border-radius: 8px;

    @media (max-width: ${theme.new.breakpoint.tabletLarge.down}) {
      padding: 5px;
      
    }
  `;
});

const Text = styled.div(({ theme }) => {
  return `
    font-size: ${theme.new.type.size[16]};

    @media (max-width: ${theme.new.breakpoint.tabletLarge.down}) {
      font-size: ${theme.new.type.size[12]};
      
    }
  `;
});

const Label = styled.label(({ theme }) => {
  return `
        font-size: ${theme.new.type.size[12]};
    `;
});

const TimeIcon = styled.img`
  width: 15px;
  margin-right: 5px;
  font-size: 1.2em;
`;

const Dot = styled.span<TaskElementProps>(({ theme, programId }) => {
  return `
      display: block;
      border-radius: 100px;
      height: 0.5rem;
      width: 0.5rem;
      background-color: ${theme.new.color.program[programId]};
      margin-right: 5px;
    `;
});

const InfoCard: React.FC<InfoCardProps> = ({ label, text, programId, type = 'text' }) => {
  return (
    <CardContainer>
      <Label>{label}</Label>
      <InnerContainer>
        {type === 'time' && <TimeIcon src={ClockSVG} />}
        {type === 'program' && typeof programId === 'number' && <Dot programId={programId} />}
        <Text>{text}</Text>
      </InnerContainer>
    </CardContainer>
  );
};

export default InfoCard;
